import React, { PureComponent } from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { compose } from 'redux';

import { IconTypes, LargeButton } from '@ac/kiosk-components';

import { WithStyles, withStyles } from '@material-ui/styles';

import { ScannerData } from '../../types/Api/Reservation';

import ScannerModal from './ScannerModal';

interface PassedProps {
  onSubmit: (values: ScannerData) => void;
}

interface QrScannerButtonProps extends PassedProps, WithTranslation {}

interface QrScannerButtonState {
  isScannerModalOpen: boolean;
}

class QrScannerButton extends PureComponent<
  QrScannerButtonProps,
  QrScannerButtonState
> {
  public state = {
    isScannerModalOpen: false,
  };

  public render() {
    const { t } = this.props;
    const { isScannerModalOpen } = this.state;

    return (
      <>
        <ScannerModal
          isOpen={isScannerModalOpen}
          onToggle={this.onModalToggle}
          onScan={this.onScan}
        />
        <LargeButton
          className="spacing-bottom-xxlg"
          onClick={this.onModalToggle}
          icon={IconTypes.qrCode}
        >
          {t('SCAN_QR_CODE')}
        </LargeButton>
      </>
    );
  }

  private onScan = (values: ScannerData) => {
    this.props.onSubmit(values);
    this.onModalToggle();
  };

  private onModalToggle = () => {
    const { isScannerModalOpen } = this.state;
    this.setState({ isScannerModalOpen: !isScannerModalOpen });
  };
}

export default compose(withTranslation())(QrScannerButton) as (
  props: PassedProps
) => JSX.Element;
